import React from 'react';
import { url } from '../../../Config';

function WizPacGraph() {
    const id = localStorage.getItem("userID");
    return (
        <div>
            <iframe src={`${url}/api/new-performance-data-frame/${id}`}
                    frameBorder="0"
                    style={{width: '100%', height: '100vh'}}></iframe>
        </div>
    );
}

export default WizPacGraph;